export const getLoweredMenuItemName = item => {
  return item.name.toLowerCase().replace(/\s/g, '');
};

export const defs = {
  activeMenuItem: 'activeMenuItem',
};
